import * as mgt from "@microsoft/mgt";

export default {
  install(Vue, { store }) {
    Vue.prototype.$mgt = mgt;
    mgt.Providers.globalProvider = new mgt.SimpleProvider(
      store._actions["login/getToken"][0]
    );
    store.state.login.provider = mgt.Providers.globalProvider;
    store.$mgt = mgt;
    window.mgt = mgt;
  },
};
